// extracted by mini-css-extract-plugin
module.exports = {"emailContainer":"EmailContainer_emailContainer__3LbYw","titleContainer":"EmailContainer_titleContainer__3nrvl"};